export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.REACT_APP_YANDEX_MAP_KEY;
